import React, { Component } from 'react';

import {
	Icon, Popover, Pane, toaster, Text,
} from 'evergreen-ui';

import { StyledForm } from '../utilities/styledComponents/StyledForm';
import api from '../../services/api';

export default class FormAdsTemplate extends Component {
	constructor(props) {
		super(props);

		this.state = {
			title: '',
			templateType: null,
			objective: '',
			templateTypes: [],
			fields: [],
			objectiveOptions: [
				{ value: 1, label: 'Institucional / Marca / Impressão' },
				{ value: 2, label: 'Performance / Clicks' },
			],
		};

		this.getFieldsTemplate = this.getFieldsTemplate.bind(this);
		this.handleMultipleFields = this.handleMultipleFields.bind(this);
		this.getTemplateType();
		if (props.id) {
			this.getTemplate(props.id);
		}
	}

	handleField = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		return this.setState({ [key]: value });
	};

	handleForm = (e) => {
		e.preventDefault();
		const { title, templateType, objective } = this.state;
		const { redirectSuccess, messageSuccess, id } = this.props;

		if (!title || !templateType || !objective) {
			toaster.danger('Ops! É necessário preencher todos os campos.');
			return false;
		}

		const data = this.filterDataForm();

		if (id) {
			return this.updateTemplate(id, data, messageSuccess, redirectSuccess);
		}

		return this.createTemplate(data, messageSuccess, redirectSuccess);
	};

	createTemplate = (data, messageSuccess, redirectSuccess) => api.post('/ads_templates', data)
		.then(() => {
			toaster.success(messageSuccess || '');
			if (redirectSuccess) {
				window.location.href = redirectSuccess;
			}
		})
		.catch(error => toaster.danger(`${error.message}`));

	updateTemplate = (id, data, messageSuccess, redirectSuccess) => api.put(`/ads_templates/${id}`, data)
		.then(() => {
			toaster.success(messageSuccess || '');
			if (redirectSuccess) {
				window.location.href = redirectSuccess;
			}
		})
		.catch(error => toaster.danger(`${error.message}`));

	getTemplate = id => api.get(`/ads_templates/${id}`)
		.then(response => this.setState({
			templateType: response.data.data.relationships.template_type,
			fields: response.data.data.attributes.template_fields,
			objective: response.data.data.attributes.objective,
			title: response.data.data.attributes.title,
		}))
		.catch(error => toaster.danger(`${error.message}`));

	filterDataForm = () => {
		const {
			title,
			templateType,
			objective,
			fields,
		} = this.state;

		return {
			title,
			ads_template_type_id: templateType.id,
			objective,
			fields,
			published: true,
		};
	};

	handleMultipleFields = (e, index) => {
		const value = e.target.value;
		const { fields } = this.state;
		const thisFields = Object.assign([], fields);
		thisFields[index].value = value;
		this.setState({
			fields: thisFields,
		});
	};

	getTemplateType = () => {
		api.get('/ads_template_types')
			.then(result => this.setState({ templateTypes: result.data }))
			.catch(() => toaster.danger('Falha ao carregar tipos de template'));
	};

	getFieldsTemplate = fieldsTemplate => fieldsTemplate.map(field => ({ fieldType: field.fieldType, value: '' }));

	render() {
		const {
			title,
			templateType,
			objective,
			objectiveOptions,
			templateTypes,
			fields,
		} = this.state;

		const { btnText } = this.props;

		return (
			<StyledForm onSubmit={this.handleForm}>
				<div className="form-group">
					<label htmlFor="title">Nome do template: *</label>
					<input
						name="title"
						id="title"
						value={title}
						aria-describedby="Nome do template"
						placeholder="Digite o nome do template"
						onChange={e => this.handleField(e)}
					/>
				</div>

				<div className="form-row m-0">
					<div className="form-group mr-4">
						<label htmlFor="typeTemplate">Tipo do template:*</label>
						<select
							id="templateType"
							name="templateType"
							onChange={e => this.setState({
								templateType: e.target.value ? templateTypes[e.target.value] : '',
								fields: e.target.value
									? this.getFieldsTemplate(templateTypes[e.target.value].template_fields)
									: [],
							})}
						>
							<option key="template_type_option_default" value="">Escolha um tipo...</option>
							{
								templateTypes ? templateTypes.map((item, index) => (
									<option
										key={`${item.slug}`}
										value={index}
										selected={templateType ? templateType.slug === item.slug : false}
									>
										{item.title}
									</option>
								)) : ''
							}
						</select>
					</div>

					<div className="form-group">
						<label htmlFor="objective">Objetivo: *</label>
						<select
							id="objective"
							name="objective"
							value={objective}
							onChange={e => this.handleField(e)}
						>
							<option key="objective_default" value="" selected={!objective}>Escolha um objetivo...</option>
							{
								objectiveOptions.map(option => (
									<option
										key={`objective_${option.value}`}
										value={option.value}
										selected={objective === option.value}
									>
										{option.label}
									</option>
									))
							}
						</select>
					</div>
				</div>

				<div className="form-group">
					<label>
						<span className="mr-2">Campos do canal escolhido:</span>

						<Popover
							content={() => (
								<Pane
									width={320}
									padding={15}
									display="flex"
									alignItems="center"
									justifyContent="center"
									flex0Direction="column"
									background="#4D4C59"
									color="#FFFFFF"
									fontSize="12px"
									lineheight="35px"
								>
									<Text color="white">
										Em breve...
									</Text>
								</Pane>
							)}
						>
							<Icon icon="info-sign" color="#43BCCD" className="info" />
						</Popover>
					</label>

					{
						templateType ? templateType.template_fields.map((item, index) => (
							<div key={`div_${item.fieldType})`} className="form-group mb-2">
								<input
									key={item.fieldType}
									type={item.inputType}
									name={item.fieldType}
									value={fields[index].value}
									placeholder={item.label}
									maxLength={item.size}
									onChange={e => this.handleMultipleFields(e, index)}
								/>
							</div>
						)) : ''
					}
				</div>

				<button type="submit" className="btn btn-secondary w-100">
					{btnText}
				</button>
			</StyledForm>
		);
	}
}
